module.exports = __webpack_public_path__ + "img/trending-up.4e2c0a1d.svg";